// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3NOhQ","footer":"Form_footer__1JcJl"};